import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  Form,
  Button,
  Alert,
  ProgressBar,
  Tab,
  Tabs,
  Badge,
  Accordion,
  Modal,
  ListGroup,
} from "react-bootstrap";
import {
  FaUser,
  FaBuilding,
  FaFileAlt,
  FaCheck,
  FaUpload,
  FaPhone,
  FaEnvelope,
  FaCalendarAlt,
  FaIdCard,
  FaShieldAlt,
  FaRegBuilding,
  FaMapMarkerAlt,
  FaInfoCircle,
  FaTimes,
  FaPrint,
  FaSearch,
  FaExternalLinkAlt,
  FaEdit,
} from "react-icons/fa";
import { MdPerson, MdWork, MdDescription, MdAssignment } from "react-icons/md";
import "../../styles/AgencyOnBoard.css";
import axios from "axios";
import { Baseurl } from "../../baseurl";
import { toast } from "react-toastify";

const AgencyOnboardScreen = () => {
  const [activeTab, setActiveTab] = useState("personal");
  const [formData, setFormData] = useState({
    // Personal Details
    name: "",
    fatherName: "",
    dOB: "",
    mobileNo: "",
    email: "",
    password: "",

    // Personal Documents
    personalDetails: {
      panCard: "",
      supportingDocument: null,
      passPhoto: null,
    },

    // Compliance
    compliance: {
      DRACertificate: null,
      policeVerificationReport: null,
    },

    // Company Details
    companyDetails: {
      companyName: "",
      registeredAddress: "",
      contactNumber: "",
      email: "",
      gst: "",
    },

    // Company Documents
    documents: {
      relationTypeProof: null,
      companyPAN: null,
      officeAddressProof: null,
    },

    agencyStatus: "Pending",
    applicationID: "",
  });

  const [uploadProgress, setUploadProgress] = useState({});
  const [errors, setErrors] = useState({});
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [modalData, setModalData] = useState("");
  const [applicationStatusData, setApplicationStatusData] = useState(null);
  const [checkApplicationID, setCheckApplicationID] = useState("");
  const [uploadedFiles, setUploadedFiles] = useState({});
  const [fileStatus, setFileStatus] = useState({});
  const [isEditMode, setIsEditMode] = useState(false);

  // Initialize file status from form data on component mount
  useEffect(() => {
    const status = {};
    const files = {};

    // Check personal documents
    if (formData.personalDetails.supportingDocument) {
      status["personalDetails.supportingDocument"] = "Uploaded";
      files["personalDetails.supportingDocument"] =
        formData.personalDetails.supportingDocument;
    }
    if (formData.personalDetails.passPhoto) {
      status["personalDetails.passPhoto"] = "Uploaded";
      files["personalDetails.passPhoto"] = formData.personalDetails.passPhoto;
    }

    // Check compliance documents
    if (formData.compliance.DRACertificate) {
      status["compliance.DRACertificate"] = "Uploaded";
      files["compliance.DRACertificate"] = formData.compliance.DRACertificate;
    }
    if (formData.compliance.policeVerificationReport) {
      status["compliance.policeVerificationReport"] = "Uploaded";
      files["compliance.policeVerificationReport"] =
        formData.compliance.policeVerificationReport;
    }

    // Check company documents
    if (formData.documents.relationTypeProof) {
      status["documents.relationTypeProof"] = "Uploaded";
      files["documents.relationTypeProof"] =
        formData.documents.relationTypeProof;
    }
    if (formData.documents.companyPAN) {
      status["documents.companyPAN"] = "Uploaded";
      files["documents.companyPAN"] = formData.documents.companyPAN;
    }
    if (formData.documents.officeAddressProof) {
      status["documents.officeAddressProof"] = "Uploaded";
      files["documents.officeAddressProof"] =
        formData.documents.officeAddressProof;
    }

    setFileStatus(status);
    setUploadedFiles(files);
  }, []);

  console.log(formData, "formData");

  // Calculate form completion percentage
  const calculateProgress = () => {
    const fields = [
      formData.name,
      formData.fatherName,
      formData.dOB,
      formData.mobileNo,
      formData.email,
      formData.password,
      formData.personalDetails.panCard,
      formData.companyDetails.companyName,
      formData.companyDetails.registeredAddress,
      formData.companyDetails.contactNumber,
      formData.companyDetails.email,
      formData.companyDetails.gst,
    ];

    const filledFields = fields.filter(
      (field) => field && field.toString().trim() !== "",
    ).length;
    return Math.round((filledFields / fields.length) * 100);
  };

  const handleInputChange = (section, field, value) => {
    if (section) {
      setFormData((prev) => ({
        ...prev,
        [section]: {
          ...prev[section],
          [field]: value,
        },
      }));
    } else {
      setFormData((prev) => ({
        ...prev,
        [field]: value,
      }));
    }
  };

  const handleRemoveData = async () => {
    setFormData({
      name: "",
      fatherName: "",
      dOB: "",
      mobileNo: "",
      email: "",
      password: "",
      personalDetails: {
        panCard: "",
        supportingDocument: null,
        passPhoto: null,
      },
      compliance: {
        DRACertificate: null,
        policeVerificationReport: null,
      },
      companyDetails: {
        companyName: "",
        registeredAddress: "",
        contactNumber: "",
        email: "",
        gst: "",
      },
      documents: {
        relationTypeProof: null,
        companyPAN: null,
        officeAddressProof: null,
      },
      agencyStatus: "Pending",
      applicationID: "",
    });
    setFileStatus({});
    setUploadedFiles({});
    setShowSuccessModal(false);
    setModalData("");
    setIsEditMode(false);
  };

  const handleFileUpload = async (section, field, file) => {
    if (!file) return;

    const key = `${section}.${field}`;
    setUploadProgress((prev) => ({ ...prev, [key]: 0 }));

    const formDataObj = new FormData();
    formDataObj.append("file", file);

    try {
      const res = await axios.post(`${Baseurl}/agency`, formDataObj, {
        headers: { "Content-Type": "multipart/form-data" },
        onUploadProgress: (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total,
          );
          setUploadProgress((prev) => ({ ...prev, [key]: percent }));
        },
      });

      // Store uploaded file URL
      handleInputChange(section, field, res.data.filePath);

      // Update file status and store file info
      setFileStatus((prev) => ({ ...prev, [key]: "Uploaded" }));
      setUploadedFiles((prev) => ({ ...prev, [key]: file.name }));

      toast.success(`${field} uploaded successfully!`);

      // Clear progress after 2 seconds
      setTimeout(() => {
        setUploadProgress((prev) => ({ ...prev, [key]: 0 }));
      }, 2000);
    } catch (error) {
      console.error("File upload failed:", error);
      setUploadProgress((prev) => ({ ...prev, [key]: 0 }));
      toast.error("File upload failed. Please try again.");
    }
  };

  const removeUploadedFile = (section, field) => {
    const key = `${section}.${field}`;
    handleInputChange(section, field, null);
    setFileStatus((prev) => {
      const newStatus = { ...prev };
      delete newStatus[key];
      return newStatus;
    });
    setUploadedFiles((prev) => {
      const newFiles = { ...prev };
      delete newFiles[key];
      return newFiles;
    });
    toast.info(`File removed from ${field}`);
  };

  const validateForm = () => {
    const newErrors = {};

    // Personal details validation
    if (!formData.name.trim()) newErrors.name = "Name is required";
    if (!formData.mobileNo.match(/^[0-9]{10}$/))
      newErrors.mobileNo = "Invalid mobile number";
    if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/))
      newErrors.email = "Invalid email";
    if (!formData.personalDetails.panCard.match(/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/)) {
      newErrors.panCard = "Invalid PAN format";
    }

    // Company details validation
    if (!formData.companyDetails.companyName.trim()) {
      newErrors.companyName = "Company name is required";
    }
    if (
      !formData.companyDetails.gst.match(
        /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
      )
    ) {
      newErrors.gst = "Invalid GST format";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const url = `${Baseurl}/api/agency/create`;
      try {
        const resp = await axios.post(url, formData, config);
        if (resp.data.success) {
          setModalData(resp.data?.data);
          setShowSuccessModal(true);
          setIsEditMode(false);
          toast.success(resp.data?.message);
        }
      } catch (error) {
        toast.error("Failed to submit application. Please try again.");
      }
    }
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      const config = {
        headers: {
          "Content-Type": "application/json",
        },
      };
      const url = `${Baseurl}/api/agency/update/${formData._id}`;
      try {
        const resp = await axios.put(url, formData, config);
        if (resp.data.success) {
          setModalData(resp.data?.data);
          setShowSuccessModal(true);
          setIsEditMode(false);
          toast.success(resp.data?.message);
        }
      } catch (error) {
        toast.error("Failed to submit application. Please try again.");
      }
    }
  };

  const handleCheckStatus = async () => {
    if (!checkApplicationID.trim()) {
      toast.error("Please enter Application ID");
      return;
    }

    try {
      const url = `${Baseurl}/api/agency/status/${checkApplicationID}`;
      const resp = await axios.get(url);

      if (resp.data.success) {
        setApplicationStatusData(resp.data.data);
      } else {
        toast.error(resp.data.message || "Application not found");
      }
    } catch (error) {
      toast.error("Failed to fetch application status");
    }
  };

  const handleEditAndResubmit = () => {
    if (applicationStatusData) {
      // Populate form with existing data for editing
      setFormData({
        ...applicationStatusData,
        agencyStatus: "Pending", // Reset status for resubmission
      });

      // Update file status for uploaded files
      const status = {};
      if (applicationStatusData.personalDetails?.supportingDocument) {
        status["personalDetails.supportingDocument"] = "Uploaded";
      }
      if (applicationStatusData.personalDetails?.passPhoto) {
        status["personalDetails.passPhoto"] = "Uploaded";
      }
      if (applicationStatusData.compliance?.DRACertificate) {
        status["compliance.DRACertificate"] = "Uploaded";
      }
      if (applicationStatusData.compliance?.policeVerificationReport) {
        status["compliance.policeVerificationReport"] = "Uploaded";
      }
      if (applicationStatusData.documents?.relationTypeProof) {
        status["documents.relationTypeProof"] = "Uploaded";
      }
      if (applicationStatusData.documents?.companyPAN) {
        status["documents.companyPAN"] = "Uploaded";
      }
      if (applicationStatusData.documents?.officeAddressProof) {
        status["documents.officeAddressProof"] = "Uploaded";
      }

      setFileStatus(status);
      setIsEditMode(true);
      setShowStatusModal(false);
      toast.info("You can now edit and resubmit your application");
    }
  };

  const renderFileStatus = (section, field) => {
    const key = `${section}.${field}`;
    const isUploaded = fileStatus[key] === "Uploaded";
    const isUploading = uploadProgress[key] > 0 && uploadProgress[key] < 100;

    if (!isUploaded && !isUploading) return null;

    return (
      <div className="d-flex align-items-center mt-1">
        {isUploading ? (
          <>
            <div className="spinner-border spinner-border-sm text-primary me-2" />
            <span className="text-muted small">
              Uploading... {uploadProgress[key]}%
            </span>
          </>
        ) : (
          <>
            <Badge bg="success" className="me-2">
              <FaCheck size={10} /> Uploaded
            </Badge>
            <span className="text-muted small me-2">
              {uploadedFiles[key] || "File uploaded"}
            </span>
            <Button
              variant="link"
              size="sm"
              className="p-0 text-danger"
              onClick={() => removeUploadedFile(section, field)}
            >
              <FaTimes size={12} />
            </Button>
          </>
        )}
      </div>
    );
  };

  const renderStatusModalContent = () => {
    if (!applicationStatusData) {
      return (
        <div className="text-center py-4">
          <FaSearch size={48} className="text-muted mb-3" />
          <p>Enter your Application ID to check status</p>
        </div>
      );
    }

    const { agencyStatus, applicationID, name, companyDetails } =
      applicationStatusData;

    const statusConfig = {
      Pending: {
        variant: "warning",
        icon: <FaInfoCircle className="me-2" />,
        title: "Application Under Review",
        message:
          "We are processing your application. Please check back in 24-48 hours.",
        actions: [],
      },
      Approved: {
        variant: "success",
        icon: <FaCheck className="me-2" />,
        title: "Application Approved!",
        message:
          "Congratulations! Your application has been verified successfully.",
        actions: [
          {
            label: "Login to Admin Panel",
            variant: "success",
            onClick: () =>
              window.open("https://auction.mcollect.co.in/", "_blank"),
            icon: <FaExternalLinkAlt className="me-2" />,
          },
        ],
      },
      Rework: {
        variant: "warning",
        icon: <FaEdit className="me-2" />,
        title: "Application Requires Rework",
        message:
          "Oops! Your application needs some corrections. Please edit and resubmit.",
        actions: [
          {
            label: "Edit and Resubmit",
            variant: "warning",
            onClick: handleEditAndResubmit,
            icon: <FaEdit className="me-2" />,
          },
        ],
      },
      Rejected: {
        variant: "danger",
        icon: <FaTimes className="me-2" />,
        title: "Application Rejected",
        message:
          "We cannot proceed with your application at this time. Sorry for the inconvenience.",
        actions: [],
      },
    };

    const config = statusConfig[agencyStatus] || statusConfig.Pending;

    return (
      <>
        <div className="text-center mb-4">
          <div
            className={`bg-${config.variant}-subtle p-4 rounded-circle d-inline-block`}
          >
            {config.icon}
          </div>
          <h4 className="mt-3">{config.title}</h4>
        </div>

        <ListGroup className="mb-4">
          <ListGroup.Item>
            <strong>Application ID:</strong> {applicationID}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Applicant Name:</strong> {name}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Company:</strong> {companyDetails?.companyName}
          </ListGroup.Item>
          <ListGroup.Item>
            <strong>Status:</strong>{" "}
            <Badge bg={config.variant}>{agencyStatus}</Badge>
          </ListGroup.Item>
        </ListGroup>

        <Alert variant={config.variant}>{config.message}</Alert>

        {config.actions.map((action, index) => (
          <Button
            key={index}
            variant={action.variant}
            className="w-100 mb-2"
            onClick={action.onClick}
          >
            {action.icon}
            {action.label}
          </Button>
        ))}
      </>
    );
  };

  const renderPersonalDetails = () => (
    <Card className="mb-4">
      <Card.Header className="bg-primary text-white d-flex align-items-center">
        <FaUser className="me-2" />
        <h5 className="mb-0">
          Personal Details {isEditMode && <Badge bg="warning">Editing</Badge>}
        </h5>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <MdPerson className="me-2" />
                Full Name *
              </Form.Label>
              <Form.Control
                type="text"
                value={formData.name}
                onChange={(e) =>
                  handleInputChange(null, "name", e.target.value)
                }
                isInvalid={!!errors.name}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.name}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaUser className="me-2" />
                Father's Name
              </Form.Label>
              <Form.Control
                type="text"
                value={formData.fatherName}
                onChange={(e) =>
                  handleInputChange(null, "fatherName", e.target.value)
                }
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaCalendarAlt className="me-2" />
                Date of Birth
              </Form.Label>
              <Form.Control
                type="date"
                value={formData.dOB}
                onChange={(e) => handleInputChange(null, "dOB", e.target.value)}
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaPhone className="me-2" />
                Mobile Number *
              </Form.Label>
              <Form.Control
                type="tel"
                value={formData.mobileNo}
                onChange={(e) =>
                  handleInputChange(null, "mobileNo", e.target.value)
                }
                isInvalid={!!errors.mobileNo}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.mobileNo}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaEnvelope className="me-2" />
                Email *
              </Form.Label>
              <Form.Control
                type="email"
                value={formData.email}
                onChange={(e) =>
                  handleInputChange(null, "email", e.target.value)
                }
                isInvalid={!!errors.email}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.email}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaShieldAlt className="me-2" />
                Password
              </Form.Label>
              <Form.Control
                type="password"
                value={formData.password}
                onChange={(e) =>
                  handleInputChange(null, "password", e.target.value)
                }
              />
            </Form.Group>
          </Col>
        </Row>

        <Accordion className="mt-4">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <FaFileAlt className="me-2" />
              Personal Documents
            </Accordion.Header>
            <Accordion.Body>
              <Form.Group className="mb-3">
                <Form.Label>
                  <FaIdCard className="me-2" />
                  PAN Card Number *
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="ABCDE1234F"
                  value={formData.personalDetails.panCard}
                  onChange={(e) =>
                    handleInputChange(
                      "personalDetails",
                      "panCard",
                      e.target.value,
                    )
                  }
                  isInvalid={!!errors.panCard}
                />
                <Form.Control.Feedback type="invalid">
                  {errors.panCard}
                </Form.Control.Feedback>
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  <FaUpload className="me-2" />
                  Pan Card Image
                </Form.Label>
                <Form.Control
                  type="file"
                  onChange={(e) =>
                    handleFileUpload(
                      "personalDetails",
                      "supportingDocument",
                      e.target.files[0],
                    )
                  }
                />
                {renderFileStatus("personalDetails", "supportingDocument")}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  <FaUser className="me-2" />
                  Passport Size Photo
                </Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  onChange={(e) =>
                    handleFileUpload(
                      "personalDetails",
                      "passPhoto",
                      e.target.files[0],
                    )
                  }
                />
                {renderFileStatus("personalDetails", "passPhoto")}
              </Form.Group>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Card.Body>
    </Card>
  );

  const renderComplianceDetails = () => (
    <Card className="mb-4">
      <Card.Header className="bg-warning text-dark d-flex align-items-center">
        <MdAssignment className="me-2" />
        <h5 className="mb-0">Compliance Documents</h5>
      </Card.Header>
      <Card.Body>
        <Form.Group className="mb-3">
          <Form.Label>
            <FaFileAlt className="me-2" />
            DRA Certificate
          </Form.Label>
          <Form.Control
            type="file"
            accept=".pdf,.doc,.docx"
            onChange={(e) =>
              handleFileUpload(
                "compliance",
                "DRACertificate",
                e.target.files[0],
              )
            }
          />
          {renderFileStatus("compliance", "DRACertificate")}
          <Form.Text className="text-muted">
            Upload DRA certification document
          </Form.Text>
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>
            <FaShieldAlt className="me-2" />
            Police Verification Report
          </Form.Label>
          <Form.Control
            type="file"
            accept=".pdf,.doc,.docx"
            onChange={(e) =>
              handleFileUpload(
                "compliance",
                "policeVerificationReport",
                e.target.files[0],
              )
            }
          />
          {renderFileStatus("compliance", "policeVerificationReport")}
          <Form.Text className="text-muted">
            Police verification report not older than 6 months
          </Form.Text>
        </Form.Group>
      </Card.Body>
    </Card>
  );

  const renderCompanyDetails = () => (
    <Card className="mb-4">
      <Card.Header className="bg-info text-white d-flex align-items-center">
        <FaBuilding className="me-2" />
        <h5 className="mb-0">Company Details</h5>
      </Card.Header>
      <Card.Body>
        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaRegBuilding className="me-2" />
                Company Name *
              </Form.Label>
              <Form.Control
                type="text"
                value={formData.companyDetails.companyName}
                onChange={(e) =>
                  handleInputChange(
                    "companyDetails",
                    "companyName",
                    e.target.value,
                  )
                }
                isInvalid={!!errors.companyName}
                required
              />
              <Form.Control.Feedback type="invalid">
                {errors.companyName}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaMapMarkerAlt className="me-2" />
                Registered Address *
              </Form.Label>
              <Form.Control
                as="textarea"
                rows={2}
                value={formData.companyDetails.registeredAddress}
                onChange={(e) =>
                  handleInputChange(
                    "companyDetails",
                    "registeredAddress",
                    e.target.value,
                  )
                }
              />
            </Form.Group>
          </Col>
        </Row>

        <Row>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaPhone className="me-2" />
                Contact Number
              </Form.Label>
              <Form.Control
                type="tel"
                value={formData.companyDetails.contactNumber}
                onChange={(e) =>
                  handleInputChange(
                    "companyDetails",
                    "contactNumber",
                    e.target.value,
                  )
                }
              />
            </Form.Group>
          </Col>
          <Col md={6}>
            <Form.Group className="mb-3">
              <Form.Label>
                <FaEnvelope className="me-2" />
                Company Email
              </Form.Label>
              <Form.Control
                type="email"
                value={formData.companyDetails.email}
                onChange={(e) =>
                  handleInputChange("companyDetails", "email", e.target.value)
                }
              />
            </Form.Group>
          </Col>
        </Row>

        <Form.Group className="mb-3">
          <Form.Label>
            <FaIdCard className="me-2" />
            GST Number *
          </Form.Label>
          <Form.Control
            type="text"
            placeholder="22ABCDE1234F1Z5"
            value={formData.companyDetails.gst}
            onChange={(e) =>
              handleInputChange("companyDetails", "gst", e.target.value)
            }
            isInvalid={!!errors.gst}
          />
          <Form.Control.Feedback type="invalid">
            {errors.gst}
          </Form.Control.Feedback>
        </Form.Group>

        <Accordion className="mt-4">
          <Accordion.Item eventKey="0">
            <Accordion.Header>
              <MdDescription className="me-2" />
              Company Documents
            </Accordion.Header>
            <Accordion.Body>
              <Form.Group className="mb-3">
                <Form.Label>
                  <FaFileAlt className="me-2" />
                  Partnership Deed / MOA / AOA
                </Form.Label>
                <Form.Control
                  type="file"
                  onChange={(e) =>
                    handleFileUpload(
                      "documents",
                      "relationTypeProof",
                      e.target.files[0],
                    )
                  }
                />
                {renderFileStatus("documents", "relationTypeProof")}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  <FaIdCard className="me-2" />
                  Company PAN Card
                </Form.Label>
                <Form.Control
                  type="file"
                  onChange={(e) =>
                    handleFileUpload(
                      "documents",
                      "companyPAN",
                      e.target.files[0],
                    )
                  }
                />
                {renderFileStatus("documents", "companyPAN")}
              </Form.Group>

              <Form.Group className="mb-3">
                <Form.Label>
                  <FaMapMarkerAlt className="me-2" />
                  Office Address Proof
                </Form.Label>
                <Form.Control
                  type="file"
                  onChange={(e) =>
                    handleFileUpload(
                      "documents",
                      "officeAddressProof",
                      e.target.files[0],
                    )
                  }
                />
                {renderFileStatus("documents", "officeAddressProof")}
              </Form.Group>
            </Accordion.Body>
          </Accordion.Item>
        </Accordion>
      </Card.Body>
    </Card>
  );

  return (
    <Container fluid className="py-4">
      <Row className="mb-4">
        <Col>
          <div className="d-flex justify-content-between align-items-center">
            <div>
              <h2 className="d-flex align-items-center">
                <FaBuilding className="me-3" />
                Agency Onboarding
              </h2>
              <p className="text-muted">
                Register a new agency with complete details
              </p>
            </div>
            <Button
              variant="outline-primary"
              onClick={() => setShowStatusModal(true)}
            >
              <FaSearch className="me-2" />
              Check Application Status
            </Button>
          </div>
        </Col>
      </Row>

      {/* Progress Bar */}
      <Row className="mb-4">
        <Col>
          <Card>
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span>Form Completion</span>
                <span>{calculateProgress()}%</span>
              </div>
              <ProgressBar
                now={calculateProgress()}
                label={`${calculateProgress()}%`}
              />
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Navigation Tabs */}
      <Row className="mb-4">
        <Col>
          <Tabs
            activeKey={activeTab}
            onSelect={(k) => setActiveTab(k)}
            className="mb-3"
            fill
          >
            <Tab
              eventKey="personal"
              title={
                <span>
                  <FaUser className="me-2" />
                  Personal Details
                </span>
              }
            />
            <Tab
              eventKey="company"
              title={
                <span>
                  <FaBuilding className="me-2" />
                  Company Details
                </span>
              }
            />
            <Tab
              eventKey="compliance"
              title={
                <span>
                  <MdAssignment className="me-2" />
                  Compliance
                </span>
              }
            />
          </Tabs>
        </Col>
      </Row>

      <Form onSubmit={isEditMode ? handleUpdate : handleSubmit}>
        {/* Conditional Rendering based on active tab */}
        {activeTab === "personal" && renderPersonalDetails()}
        {activeTab === "company" && renderCompanyDetails()}
        {activeTab === "compliance" && renderComplianceDetails()}

        {/* Navigation Buttons */}
        <Row className="mt-4">
          <Col className="d-flex justify-content-between">
            <Button
              variant="outline-secondary"
              onClick={() => {
                const tabs = ["personal", "company", "compliance"];
                const currentIndex = tabs.indexOf(activeTab);
                if (currentIndex > 0) setActiveTab(tabs[currentIndex - 1]);
              }}
              disabled={activeTab === "personal"}
            >
              Previous
            </Button>

            {activeTab !== "compliance" ? (
              <Button
                variant="primary"
                onClick={() => {
                  const tabs = ["personal", "company", "compliance"];
                  const currentIndex = tabs.indexOf(activeTab);
                  if (currentIndex < tabs.length - 1)
                    setActiveTab(tabs[currentIndex + 1]);
                }}
              >
                Next
              </Button>
            ) : (
              <Button variant="success" type="submit">
                <FaCheck className="me-2" />
                {isEditMode ? "Resubmit Application" : "Submit Application"}
              </Button>
            )}
          </Col>
        </Row>
      </Form>

      {/* Success Modal */}
      <Modal show={showSuccessModal} onHide={() => setShowSuccessModal(false)}>
        <Modal.Header closeButton className="bg-success text-white">
          <Modal.Title>
            <FaCheck className="me-2" />
            Application Submitted Successfully!
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Alert variant="success">
            <Alert.Heading>Application Received</Alert.Heading>
            <p>
              Your agency onboarding application has been submitted
              successfully. Your application ID is{" "}
              <strong>{modalData?.applicationID}</strong>.
            </p>
            <hr />
            <p className="mb-0">
              The application is now in <Badge bg="warning">Pending</Badge>{" "}
              status. You will be notified via email once the verification is
              complete.
            </p>
          </Alert>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={() => handleRemoveData()}>
            Close
          </Button>
          <Button
            variant="outline-success"
            onClick={() => {
              window.print();
              handleRemoveData();
            }}
          >
            <FaPrint className="me-2" />
            Print Application
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Application Status Check Modal */}
      <Modal
        show={showStatusModal}
        onHide={() => setShowStatusModal(false)}
        size="lg"
      >
        <Modal.Header closeButton className="bg-primary text-white">
          <Modal.Title>
            <FaSearch className="me-2" />
            Check Application Status
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {!applicationStatusData ? (
            <>
              <Form.Group className="mb-4">
                <Form.Label>
                  <FaIdCard className="me-2" />
                  Enter Application ID
                </Form.Label>
                <Form.Control
                  type="text"
                  placeholder="e.g., APP2023001"
                  value={checkApplicationID}
                  onChange={(e) => setCheckApplicationID(e.target.value)}
                />
                <Form.Text className="text-muted">
                  You can find your Application ID in your email or application
                  confirmation.
                </Form.Text>
              </Form.Group>
              <Button
                variant="primary"
                className="w-100"
                onClick={handleCheckStatus}
              >
                <FaSearch className="me-2" />
                Check Status
              </Button>
            </>
          ) : (
            renderStatusModalContent()
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => {
              setShowStatusModal(false);
              setApplicationStatusData(null);
              setCheckApplicationID("");
            }}
          >
            Close
          </Button>
          {applicationStatusData && (
            <Button
              variant="outline-primary"
              onClick={() => {
                setApplicationStatusData(null);
                setCheckApplicationID("");
              }}
            >
              Check Another Application
            </Button>
          )}
        </Modal.Footer>
      </Modal>
    </Container>
  );
};

export default AgencyOnboardScreen;
